module.exports = __webpack_public_path__ + "img/html.f618641c.svg";